import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { CheckBoxModule } from 'app/shared/components/check-box/check-box.module';
import { DropdownModule } from 'app/shared/components/dropdown/dropdown.module';
import { IconicModule, SvgIconModule } from 'app/shared/components/iconic/iconic.module';
import { RangeSliderModule } from 'app/shared/components/range-slider/range-slider.module';
import { TooltipModule } from 'app/shared/components/tooltip/tooltip.module';
import { TreeListModule } from 'app/shared/components/tree-list/tree-list.module';
import { LegendLayerModule } from '../legend-layer/legend-layer.module';
import { LayerListComponent } from './layer-list.component';
import { LoadingPanelModule } from '@components/loading-panel/loading-panel.module';

@NgModule({
  imports: [
    CommonModule,
    TreeListModule,
    ButtonModule,
    IconicModule,
    SvgIconModule,
    DropdownModule,
    RangeSliderModule,
    TooltipModule,
    LegendLayerModule,
    CheckBoxModule,
    LoadingPanelModule
  ],
  declarations: [LayerListComponent],
  exports: [LayerListComponent],
})
export class LayerListModule {}
